// let hostname = 'drupal-service:8080'; // prod
let hostname = 'drupal-app-service:8080'; // qa/uat

// hostname = 'dlr-backend.getdeveloper.net';
// process.env['NODE_TLS_REJECT_UNAUTHORIZED'] = '0';

// process.env['NODE_TLS_REJECT_UNAUTHORIZED'] = 0;
// process.env.NODE_TLS_REJECT_UNAUTHORIZED = 0;
export const Constants = {
  baseUrl: `http://${hostname}/`,
  baseApiUrl: `http://${hostname}/api/`,
  apiV2Url: `http://${hostname}/apiv2-dlr/`,
  languageKey: `frontend`,
  cloudinaryImage:
    'https://res.cloudinary.com/digitalrealty/image/upload/f_auto,q_auto,c_scale,dpr_auto,w_auto/',
  frontendUrl: `http://${hostname}/`,
  algoliaTest: `https://SWULV5ONQ5-dsn.algolia.net/1/indexes/`,
  algoliaProduction: `https://O2VJB2KMPB-dsn.algolia.net/1/indexes/`,
  headers: {
    method: 'GET',
    headers: {
      secret: 'DJDltNROU6PikRa',
    },
  },
  en: 'https://www.digitalrealty.com',
  de: 'https://www.digitalrealty.com/de',
  fr: 'https://www.digitalrealty.com/fr',
  uk: 'https://www.digitalrealty.com',
  nl: 'https://www.digitalrealty.com',
  kr: 'https://www.digitalrealty.com/ko',
  cn: 'https://www.digitalrealty.com/zh',
  jp: 'https://www.digitalrealty.com',
  asia: 'https://www.digitalrealty.com',
  es: 'https://www.digitalrealty.com/es',
  ch: 'https://www.digitalrealty.com/de',
  at: 'https://www.digitalrealty.com/de',
  gr: 'https://www.digitalrealty.com',
  dk: 'https://www.digitalrealty.com',
  se: 'https://www.digitalrealty.com',
  be: 'https://www.digitalrealty.com',
  ie: 'https://www.digitalrealty.com',
  it: 'https://www.digitalrealty.com/it',
};

export const getBackendUrl = (host) => {
  // let hostname = 'http://drupal-service:8080'; //prod
  let hostname = 'http://drupal-app-service:8080'; // qa/uat
  let hostnameRemote = 'https://uat-cms.digitalrealty.com';
  let frontendGlobal = 'https://digitalrealty.com/';
  let glossaryRemote = '';

  if (!host) {
    return hostnameRemote;
  }
  if (
    host == 'digitalrealty.com' ||
    host === 'www.digitalrealty.com' ||
    host === 'www.digitalrealty.de' ||
    host === 'www.digitalrealty.nl' ||
    host === 'www.digitalrealty.co.uk' ||
    host == 'digitalrealty.de' ||
    host == 'digitalrealty.nl' ||
    host == 'digitalrealty.co.uk' ||
    host == 'digitalrealty.asia' ||
    host == 'digitalrealty.kr' ||
    host == 'www.digitalrealty.asia' ||
    host == 'www.digitalrealty.kr' ||
    host == 'digitalrealty.fr' ||
    host == 'digitalrealty.es' ||
    host == 'www.digitalrealty.fr' ||
    host == 'www.digitalrealty.es' ||
    host == 'www.digitalrealty.at' ||
    host == 'www.digitalrealty.ch' ||
    host == 'digitalrealty.ch' ||
    host == 'digitalrealty.at' ||
    host == 'www.digitalrealty.ie' ||
    host == 'digitalrealty.ie' ||
    host == 'www.digitalrealty.be' ||
    host == 'www.digitalrealty.gr' ||
    host == 'digitalrealty.be' ||
    host == 'www.digitalrealty.se' ||
    host == 'digitalrealty.se' ||
    host == 'www.digitalrealty.dk' ||
    host == 'digitalrealty.dk' ||
    host == 'digitalrealty.cn' ||
    host == 'www.digitalrealty.cn' ||
    host == 'digitalrealty.gr' ||
    host == 'www.digitalrealty.it' ||
    host == 'digitalrealty.it'
  ) {
    hostnameRemote = 'https://cms.digitalrealty.com';
    frontendGlobal = 'https://www.digitalrealty.com/';
    glossaryRemote = 'https://cms.digitalrealty.com';
  } else if (host.includes('uat')) {
    hostnameRemote = 'https://uat-cms.digitalrealty.com';
    frontendGlobal = 'https://uat.digitalrealty.com/';
    glossaryRemote = 'https://uat-cms.digitalrealty.com';
  } else if (host.includes('localhost')) {
    hostnameRemote = 'https://dlr-backend.getdeveloper.net';
    hostname = 'https://dlr-backend.getdeveloper.net';
    frontendGlobal = 'https://dlr-frontend.getdeveloper.net/';
    glossaryRemote = 'https://dlr-backend.getdeveloper.net';
    // hostname = 'http://html.test';
    // hostnameRemote = 'http://html.test';
    // frontendGlobal = 'http://html.test';
    // glossaryRemote = 'http://html.test';
  } else if (host.includes('getdeveloper.net')) {
    hostnameRemote = 'https://dlr-backend.getdeveloper.net';
    frontendGlobal = 'https://dlr-frontend.getdeveloper.net/';
    glossaryRemote = 'https://dlr-backend.getdeveloper.net';
  }

  // hostname = 'http://dlr-cms.test';

  return {
    baseUrl: hostname,
    baseApiUrl: `${hostname}/api/`,
    baseApiUrlRemote: `${glossaryRemote}/api/`,
    apiV2Url: `${hostname}/apiv2-dlr/`,
    remoteServer: `${hostnameRemote}/apiv2-dlr/`,
    frontend: frontendGlobal,
  };
};
